import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_ERROR_REPORTS_BEGIN = "FETCH_ERROR_REPORTS_BEGIN"
export const FETCH_ERROR_REPORTS_SUCCESS = "FETCH_ERROR_REPORTS_SUCCESS"
export const FETCH_ERROR_REPORTS_ERROR = "FETCH_ERROR_REPORTS_ERROR"

export const fetchErrorReportsBegin = () => ({
	type: FETCH_ERROR_REPORTS_BEGIN,
})

export const fetchErrorReportsSuccess = (reports, append = false) => ({
	type: FETCH_ERROR_REPORTS_SUCCESS,
	payload: { reports, append },
})

export const fetchErrorReportsError = (error) => ({
	type: FETCH_ERROR_REPORTS_ERROR,
	payload: error,
})

// statut : actifs (défaut) | traites | tous. q : recherche message/type.
// Le thunk résout avec le json reçu (le composant en déduit s'il reste des
// pages, comme /signalements).
export function fetchErrorReports(statut = "actifs", opts = {}) {
	const { q = "", limit = 50, offset = 0, append = false } = opts
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		dispatch(fetchErrorReportsBegin())
		let url = `${URL}api/errorreports?statut=${statut}&limit=${limit}&offset=${offset}`
		if (q) url += `&q=${encodeURIComponent(q)}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchErrorReportsSuccess(json, append))
				return json
			})
			.catch(catchApiError(dispatch, fetchErrorReportsError))
	}
}

// Détail d'un rapport (traceback inclus) — pas de slice : le modal le tient en
// état local. Résout avec le json.
export function fetchErrorReportDetail(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/errorreports?id=${id}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.catch(catchApiError(dispatch, null))
	}
}

// Marque traité : { ids: [...] } ou { tous: true }. Le composant refetch
// lui-même (il connaît son statut/recherche/pagination courants).
export function marquerErreursTraitees(payload) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/errorreports`, {
			method: "put",
			headers: {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		}).then(handleErrors)
	}
}
